export default "__VITE_ASSET__CwQX$aXR__"